{
  "jira-forms-conditional-fields-changeboarding.spotlight.body.no-translate": [
    {
      "type": 0,
      "value": "Create conditions to have more control over the information you receive."
    }
  ],
  "jira-forms-conditional-fields-changeboarding.spotlight.heading.no-translate": [
    {
      "type": 0,
      "value": "Show fields based on previous responses"
    }
  ],
  "jira-forms-conditional-fields-changeboarding.spotlight.ok.no-translate": [
    {
      "type": 0,
      "value": "Ok"
    }
  ]
}